/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_CurrentInputs */

const id_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build saat ini`)
};

const ms_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaan semasa`)
};

const da_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelt build`)
};

const de_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktueller Build`)
};

const en_us2_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current build`)
};

const es_es2_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilación actual`)
};

const es_mx2_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilación actual`)
};

const fil_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasalukuyang build`)
};

const fr_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build actuel`)
};

const it_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build corrente`)
};

const hu_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelenlegi build`)
};

const nl_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huidige build`)
};

const no_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gjeldende build`)
};

const pl_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bieżący build`)
};

const pt_br2_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build atual`)
};

const pt_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilação atual`)
};

const ro_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buildul curent`)
};

const fi_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nykyinen build`)
};

const sv_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuell build`)
};

const vi_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build hiện tại`)
};

const tr_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geçerli derleme`)
};

const cs_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuální build`)
};

const bg_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текуща компилация`)
};

const ru_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущая сборка`)
};

const uk_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поточний білд`)
};

const ar_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البناء الحالي`)
};

const hi_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान बिल्ड`)
};

const th_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บิลด์ปัจจุบัน`)
};

const ja_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在のビルド`)
};

const zh_cn2_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前构建`)
};

const zh_hant1_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前組建`)
};

const ko_builds_comparison_current = /** @type {(inputs: Builds_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 빌드`)
};

/**
* | output |
* | --- |
* | "Current build" |
*
* @param {Builds_Comparison_CurrentInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_current = /** @type {((inputs?: Builds_Comparison_CurrentInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_CurrentInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_current(inputs)
	if (locale === "ms") return ms_builds_comparison_current(inputs)
	if (locale === "da") return da_builds_comparison_current(inputs)
	if (locale === "de") return de_builds_comparison_current(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_current(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_current(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_current(inputs)
	if (locale === "fil") return fil_builds_comparison_current(inputs)
	if (locale === "fr") return fr_builds_comparison_current(inputs)
	if (locale === "it") return it_builds_comparison_current(inputs)
	if (locale === "hu") return hu_builds_comparison_current(inputs)
	if (locale === "nl") return nl_builds_comparison_current(inputs)
	if (locale === "no") return no_builds_comparison_current(inputs)
	if (locale === "pl") return pl_builds_comparison_current(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_current(inputs)
	if (locale === "pt") return pt_builds_comparison_current(inputs)
	if (locale === "ro") return ro_builds_comparison_current(inputs)
	if (locale === "fi") return fi_builds_comparison_current(inputs)
	if (locale === "sv") return sv_builds_comparison_current(inputs)
	if (locale === "vi") return vi_builds_comparison_current(inputs)
	if (locale === "tr") return tr_builds_comparison_current(inputs)
	if (locale === "cs") return cs_builds_comparison_current(inputs)
	if (locale === "bg") return bg_builds_comparison_current(inputs)
	if (locale === "ru") return ru_builds_comparison_current(inputs)
	if (locale === "uk") return uk_builds_comparison_current(inputs)
	if (locale === "ar") return ar_builds_comparison_current(inputs)
	if (locale === "hi") return hi_builds_comparison_current(inputs)
	if (locale === "th") return th_builds_comparison_current(inputs)
	if (locale === "ja") return ja_builds_comparison_current(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_current(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_current(inputs)
	return ko_builds_comparison_current(inputs)
});
export { builds_comparison_current as "builds.comparison.current" }